import { useEffect, useState } from 'react';
import { Button, Form, ListGroup, Offcanvas } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import SearchBox from '../../../../Components/SearchBox';
import { handleOfficeKindListChange } from '../../../../Redux/slices/table';
import { debounce } from '../../../../_helpers/_methods';
import { getProvinces, getThematicAreas } from './eventFilter';
import ExpectedParticipantSection from './ExpectedParticipantSection';

function FilterOffCanvas({ show, handleClose, handleEventsFetch, eventFilters }) {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.local.local);
  const {
    IsMtot,
    IsVirtual,
    IsPhysical,
    EventType,
    Organizer,
    TargetedProvinces,
    ThematicAreas,
    Sectors
  } = eventFilters;
  const provinces = useSelector((state) => state.eventFilter.provinces);
  const [filteredThematicAreas, setFilteredThematicAreas] = useState([]);
  const fetchedThematicAreas = useSelector((state) => state.eventFilter.thematicAreas);
  const loadingThematicArea = useSelector((state) => state.eventFilter.loadingThematicArea);
  const fetchedOfficeTypes = useSelector((state) => {
    if (state.table.results) {
      return state.table.results;
    } else {
      return [];
    }
  });

  useEffect(() => {
    dispatch(getThematicAreas({}));
    dispatch(getProvinces());
    dispatch(handleOfficeKindListChange({ index: 0, pageSize: 50 }));
  }, []);

  useEffect(() => {
    setFilteredThematicAreas(fetchedThematicAreas);
  }, [fetchedThematicAreas]);

  const [isMtot, setIsMtot] = useState(IsMtot);
  useEffect(() => {
    setIsMtot(IsMtot);
  }, [IsMtot]);

  const [isVirtual, setIsVirtual] = useState(IsVirtual);
  useEffect(() => {
    setIsVirtual(IsVirtual);
  }, [IsVirtual]);

  const [isPhysical, setIsPhysical] = useState(IsPhysical);
  useEffect(() => {
    setIsPhysical(IsPhysical);
  }, [IsPhysical]);

  const [eventType, setEventType] = useState(EventType);
  useEffect(() => {
    setEventType(EventType);
  }, [EventType]);

  const [organizer, setOrganizer] = useState(Organizer);
  useEffect(() => {
    setOrganizer(Organizer);
  }, [Organizer]);

  const [selectedSectors, setSelectedSectors] = useState([]);
  useEffect(() => {
    setSelectedSectors(Sectors || []);
  }, [Sectors]);

  const [targetedProvince, setTargetedProvince] = useState(TargetedProvinces || []);
  useEffect(() => {
    setTargetedProvince(TargetedProvinces || []);
  }, [TargetedProvinces]);

  const [selectedThematicAreas, setSelectedThematicAreas] = useState(ThematicAreas || []);
  useEffect(() => {
    setSelectedThematicAreas(ThematicAreas || []);
  }, [ThematicAreas]);

  const [provinceOptions, setProvinceOptions] = useState([]);
  useEffect(() => {
    setProvinceOptions(provinces);
  }, [provinces]);

  const handleMtotChange = (event) => {
    setIsMtot(event.target.checked);
  };
  const handleVirtualChange = (event) => {
    setIsVirtual(event.target.checked);
  };
  const handlePhysicalChange = (event) => {
    setIsPhysical(event.target.checked);
  };
  const handleEventTypeChange = (event) => {
    setEventType(event.target.value);
  };
  const handleOrganizerChange = (event) => {
    let checkedOrganizer = JSON.parse(event.target.getAttribute('data-office_type'));
    setOrganizer(checkedOrganizer);
  };

  const handleFilter = () => {
    handleClose();
    handleEventsFetch({
      IsMtot: isMtot,
      IsPhysical: isPhysical,
      IsVirtual: isVirtual,
      EventType: eventType,
      Organizer: organizer,
      TargetedProvinces: targetedProvince,
      ThematicAreas: selectedThematicAreas,
      Sectors: selectedSectors
    });
  };

  const handleTargetedProvinceChange = (e) => {
    let tempSelectedThematicAreas = [...targetedProvince];
    let checkedProvince = JSON.parse(e.target.getAttribute('data-province'));
    let targetedProvinceIndex = tempSelectedThematicAreas.findIndex(
      (targetedProvince) => targetedProvince.id === checkedProvince.id
    );
    if (targetedProvinceIndex === -1) {
      tempSelectedThematicAreas.push(checkedProvince);
    } else {
      tempSelectedThematicAreas.splice(targetedProvinceIndex, 1);
    }
    setTargetedProvince(tempSelectedThematicAreas);
  };

  const handleThematicAreaChange = (e) => {
    let tempSelectedThematicAreas = [...selectedThematicAreas];
    let checkedThematicArea = JSON.parse(e.target.getAttribute('data-thematicarea'));
    let thematicAreaIndex = tempSelectedThematicAreas.findIndex(
      (thematicArea) => thematicArea.id === checkedThematicArea.id
    );
    if (thematicAreaIndex === -1) {
      tempSelectedThematicAreas.push(checkedThematicArea);
    } else {
      tempSelectedThematicAreas.splice(thematicAreaIndex, 1);
    }
    setSelectedThematicAreas(tempSelectedThematicAreas);
  };

  const handleSectorsChange = (e) => {
    let tempSelectedSectors = [...selectedSectors];
    let checkedSector = JSON.parse(e.target.getAttribute('data-sector'));
    let SectorIndex = tempSelectedSectors.findIndex((sector) => sector.id === checkedSector.id);
    if (SectorIndex === -1) {
      tempSelectedSectors.push(checkedSector);
    } else {
      tempSelectedSectors.splice(SectorIndex, 1);
    }
    setSelectedSectors(tempSelectedSectors);
  };

  const handleThematicAreaSearch = async (e) => {
    try {
      let props = {};
      if (lang === 'ne') {
        props.title_nepali = e.target.value;
      } else {
        props.title_english = e.target.value;
      }
      dispatch(getThematicAreas(props));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Offcanvas show={show} onHide={handleClose}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <h3>
            <FormattedMessage id="event.filter" />{' '}
          </h3>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <ListGroup variant="flush">
          <ListItem>
            <div className="head">
              <FormattedMessage id="event.thematicArea" />
            </div>
            <div className="mb-2">
              <SearchBox
                className=""
                placeholder={lang === 'ne' ? 'विषयगत क्षेत्र खोज्नुहोस' : 'Search Thematic areas'}
                onChange={debounce(handleThematicAreaSearch, 800)}
              />
            </div>
            <div className="body">
              {loadingThematicArea ? (
                <div>Loading</div>
              ) : (
                <div onChange={handleThematicAreaChange}>
                  {filteredThematicAreas.map((thematicArea, index) => {
                    let isChecked = false;
                    selectedThematicAreas.forEach((area) => {
                      if (area.id === thematicArea.id) {
                        isChecked = true;
                      }
                    });
                    return (
                      <Form.Check
                        key={`${index}`}
                        id={thematicArea.id}
                        type="checkbox"
                        label={thematicArea.title_nepali}
                        defaultChecked={isChecked}
                        data-thematicarea={JSON.stringify({
                          id: thematicArea.id,
                          title: thematicArea.title_nepali
                        })}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          </ListItem>
          <ListItem>
            <div className="head">
              <FormattedMessage id="filter.targeted_province" />
            </div>
            <div onChange={handleTargetedProvinceChange}>
              {provinceOptions.map((province) => {
                let isChecked = false;
                targetedProvince.forEach((p) => {
                  if (p.id === province.id) {
                    isChecked = true;
                  }
                });
                return (
                  <Form.Check
                    key={province.id}
                    id={`province-${province.id}`}
                    type="checkbox"
                    label={province.title}
                    value={province.id}
                    defaultChecked={isChecked}
                    data-province={JSON.stringify({ id: province.id, title: province.title })}
                  />
                );
              })}
            </div>
          </ListItem>
          <ListItem>
            <div className="head">
              <FormattedMessage id="filter.event_type" />
            </div>
            <div onChange={handleEventTypeChange} key={eventType}>
              <FormattedMessage id="filter.public">
                {(label) => (
                  <Form.Check
                    name="eventType"
                    id="public"
                    type="radio"
                    value="public"
                    label={label[0]}
                    defaultChecked={eventType === 'public'}
                    onChange={() => {}}
                  />
                )}
              </FormattedMessage>

              <FormattedMessage id="filter.closed">
                {(label) => (
                  <Form.Check
                    name="eventType"
                    id="closed"
                    type="radio"
                    value="closed"
                    label={label[0]}
                    defaultChecked={eventType === 'closed'}
                    onChange={() => {}}
                  />
                )}
              </FormattedMessage>

              <FormattedMessage id="filter.clear_filter">
                {(label) => (
                  <Form.Check
                    name="eventType"
                    id="clear"
                    type="radio"
                    value="clear"
                    label={label[0]}
                    defaultChecked={eventType === 'clear'}
                    onChange={() => {}}
                  />
                )}
              </FormattedMessage>
            </div>
          </ListItem>
          <ListItem>
            <div className="head">
              <FormattedMessage id="event.organizer" />
            </div>
            <div onChange={handleOrganizerChange}>
              {fetchedOfficeTypes.map((officeType) => (
                <Form.Check
                  id={officeType.id}
                  key={officeType.id}
                  name="organizer"
                  type="radio"
                  label={officeType.title}
                  value={officeType.id}
                  defaultChecked={organizer?.title === officeType.title}
                  onChange={() => {}}
                  data-office_type={JSON.stringify({
                    id: officeType.id,
                    title: officeType.title
                  })}
                />
              ))}
            </div>
          </ListItem>
          <ListItem>
            <div className="head">
              <FormattedMessage id="event.expectedParticipants" />
            </div>
            <div>
              <ExpectedParticipantSection
                selectedSectors={selectedSectors}
                handleSectorsChange={handleSectorsChange}
              />
            </div>
          </ListItem>
          <ListItem>
            <div className="head">MTOT</div>
            <div>
              <Form.Check
                id="mtot"
                type="checkbox"
                label="is MTOT event"
                checked={isMtot}
                onChange={handleMtotChange}
              />
            </div>
          </ListItem>
          <ListItem>
            <div className="head">
              <FormattedMessage id="event.nature" />
            </div>
            <div>
              <FormattedMessage id="filter.physical">
                {(label) => (
                  <Form.Check
                    id="physical"
                    type="checkbox"
                    label={label[0]}
                    checked={isPhysical}
                    onChange={handlePhysicalChange}
                  />
                )}
              </FormattedMessage>
              <FormattedMessage id="filter.virtual">
                {(label) => (
                  <Form.Check
                    id="virtual"
                    type="checkbox"
                    label={label[0]}
                    checked={isVirtual}
                    onChange={handleVirtualChange}
                  />
                )}
              </FormattedMessage>
            </div>
          </ListItem>
          <ListItem>
            <Button variant="primary" onClick={handleFilter}>
              <FormattedMessage id="filter.search" />
            </Button>
          </ListItem>
        </ListGroup>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default FilterOffCanvas;

const ListItem = styled(ListGroup.Item)`
  display: flex;
  flex-direction: column;
  .head {
    font-weight: bold;
    font-size: 1.2rem;
    margin-bottom: 0.25rem;
  }
  .body {
    max-height: 500px;
    overflow: auto;
  }
`;
